import { render, staticRenderFns } from "./framework_badge.vue.js?vue&type=template&id=72302bdb&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./framework_badge.vue?vue&type=template&id=72302bdb&vue3"
import script from "./framework_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./framework_badge.vue?vue&type=script&lang=js&vue3"
export * from "./framework_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./framework_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports